import { render, staticRenderFns } from "./Wp_home_module_page.vue?vue&type=template&id=33a8877a&scoped=true&"
import script from "./Wp_home_module_page.vue?vue&type=script&lang=js&"
export * from "./Wp_home_module_page.vue?vue&type=script&lang=js&"
import style0 from "./Wp_home_module_page.vue?vue&type=style&index=0&id=33a8877a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a8877a",
  null
  
)

export default component.exports